<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>

<style lang="stylus">
  .el-container{
    font-size 12px!important
  }
</style>
